import { render, staticRenderFns } from "./CategoriaGastos.vue?vue&type=template&id=61982dd3"
import script from "./CategoriaGastos.vue?vue&type=script&lang=js"
export * from "./CategoriaGastos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports